<template>
  <div class="profile__block__content profile__block__content--your-performance">
    <div class="stats-cont">
      <div class="stats-cont__item">
        <h4>{{ getTranslations.home_profile_profile_games }}</h4>
        <div class="progress-barv2">
          <div id="gamesWon" class="bar">
             <span class="perc">{{ gamesWonPercentRatio }}%
               ({{ numberFormatting(userInfo.gamesWon || 0)}}/{{ numberFormatting(userInfo.gamesPlayed || 0)}})
               {{ getTranslations.home_profile_default_content_games_won }}
             </span>
          </div>
        </div>
      </div>
      <div class="stats-cont__item">
        <h4>{{ getTranslations.home_profile_default_content_answers }}</h4>
        <div class="progress-barv2">
          <div id="correctAnswers" class="bar">
            <span class="perc">{{ correctAnswersPercentRatio }}%
              ({{ numberFormatting(userInfo.correctAnswersGiven || 0)}}/{{ numberFormatting(userInfo.answersGiven || 0)}})
              {{ getTranslations.home_profile_default_content_correct_answers }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { updateProgressBarGamesWon, updateProgressBarAnswersPercent } from '@/common/jQuery';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';

export default {
  name: 'stat-performance',
  mixins: [NumbersFormattingMixin],
  props: {
    userInfo: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.renderProgressBar();
  },
  updated() {
    this.renderProgressBar();
  },
  methods: {
    renderProgressBar() {
      // console.clear();
      this.$nextTick(() => {
        updateProgressBarGamesWon(this.gamesWonPercentRatio);
        updateProgressBarAnswersPercent(this.correctAnswersPercentRatio);
      });
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    gamesWonPercentRatio() {
      if (!this.userInfo.gamesPlayed) return 0;
      return Math.round((this.userInfo.gamesWon / this.userInfo.gamesPlayed) * 100);
    },
    correctAnswersPercentRatio() {
      if (!this.userInfo.answersGiven) return 0;
      return Math.round((this.userInfo.correctAnswersGiven / this.userInfo.answersGiven) * 100);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/StatPerformance.vue